import { Action, createReducer, on } from '@ngrx/store';
import { LoginSettingsActions } from '../actions';
import { LoginSettings } from '@anecdotes/api-contracts';

export interface LoginSettingsState {
  loginSettings: LoginSettings;
  loginSettingsBeforeUpdate: LoginSettings;
}

const initialState: LoginSettingsState = {
  loginSettings: null,
  loginSettingsBeforeUpdate: null
};

const adapterReducer = createReducer(
  initialState,
  on(LoginSettingsActions.Load, (state) => {
    return {
      ...state,
      loginSettings: null,
    };
  }),
  on(LoginSettingsActions.Loaded, (state, action) => {
    return {
      ...state,
      loginSettings: action.loginSettings,
    };
  }),
  on(LoginSettingsActions.ToggleIdp, (state, action) => {
    return {
      ...state,
      loginSettings: {
        ...state.loginSettings,
        idps: {
          ...state.loginSettings.idps,
          [action.idpId]: !state.loginSettings.idps[action.idpId],
        },
      },
      loginSettingsBeforeUpdate: state.loginSettings
    };
  }),
  on(LoginSettingsActions.ToggleEmailLogin, (state, action) => {
    return {
      ...state,
      loginSettings: {
        ...state.loginSettings,
        email_login: {
          ...state.loginSettings.email_login,
          [action.settingId]: !state.loginSettings.email_login[action.settingId],
        },
      },
      loginSettingsBeforeUpdate: state.loginSettings
    };
  }),
  on(LoginSettingsActions.ToggleSupportTeamLogin, (state) => {
    return {
      ...state,
      loginSettings: {
        ...state.loginSettings,
        support_team_login: !state.loginSettings.support_team_login,
      },
      loginSettingsBeforeUpdate: state.loginSettings
    };
  }),
  on(LoginSettingsActions.ChangesSaved, (state) => {
    return {
      ...state,
      loginSettingsBeforeUpdate: null
    };
  }),
  on(LoginSettingsActions.SaveChangesFailed, (state) => {
    return {
      ...state,
      loginSettings: state.loginSettingsBeforeUpdate,
      loginSettingsBeforeUpdate: null
    };
  }),
);

export function loginSettingsReducer(state, action: Action): LoginSettingsState {
  return adapterReducer(state, action);
}
